var $168501f8ff8ad607$exports = {};
$168501f8ff8ad607$exports = {
    "pending": `in behandeling`
};


export {$168501f8ff8ad607$exports as default};
//# sourceMappingURL=nl-NL.module.js.map
